import { useMemo } from 'react';

export const useGetQueueMenuItems = ({
  enableWarrantyRegistration = false,
  ptoQueue = false,
  enableGeothermal = false,
  isLightReachQCTech = false,
  isLightReachSupport = false,
  defaultQueueFilterAsReadyAndReReview = [],
  defaultQueueFilterAsNotReady = [],
}: {
  enableWarrantyRegistration?: boolean;
  ptoQueue?: boolean;
  enableGeothermal?: boolean;
  isLightReachQCTech?: boolean;
  isLightReachSupport?: boolean;
  defaultQueueFilterAsReadyAndReReview?: any[];
  defaultQueueFilterAsNotReady?: any[];
}) => {
  return useMemo(() => {
    return [
      {
        name: 'Identity Upload',
        path: '/queue/review-identity',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Title Upload',
        path: '/queue/review-title',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Voided Check Upload',
        path: '/queue/voided-check',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Supporting Upload',
        path: '/queue/review-supporting',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Disclosure Upload',
        path: '/queue/review-disclosure',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Utility Bill Upload',
        path: '/queue/review-utility-bill',
        defaultFilters: defaultQueueFilterAsReadyAndReReview,
      },
      {
        name: 'Domestic Content',
        path: '/queue/domestic-content',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      {
        name: 'Install Package',
        path: '/queue/install-package',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      ...(ptoQueue
        ? [
            {
              name: 'PTO Package',
              path: '/queue/pto-package',
              defaultFilters: defaultQueueFilterAsNotReady,
            },
          ]
        : []),
      {
        name: 'Activation Package',
        path: '/queue/activation-package',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      {
        name: 'Post Activation Package',
        path: '/queue/post-activation-package',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      {
        name: 'Electrician Sign-off',
        path: '/queue/electrician-sign-off',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      {
        name: 'Site Assessment',
        path: '/queue/site-assessment',
        defaultFilters: defaultQueueFilterAsNotReady,
      },
      ...(enableGeothermal
        ? [
            {
              name: 'GSHP Design Documents',
              path: '/queue/loop-field-design-documents',
              defaultFilters: defaultQueueFilterAsReadyAndReReview,
            },
            {
              name: 'Loop Field Package',
              path: '/queue/loop-field-package',
              defaultFilters: defaultQueueFilterAsNotReady,
            },
          ]
        : []),
      ...(enableWarrantyRegistration
        ? [
            {
              name: 'Warranty Registration',
              path: '/queue/warranty-registration',
              defaultFilters: defaultQueueFilterAsNotReady,
            },
          ]
        : []),
      ...(isLightReachQCTech
        ? [
            {
              name: 'Hold Queue',
              path: '/queue/hold-motion',
              defaultFilters: [],
            },
          ]
        : []),
      ...(isLightReachSupport
        ? [
            {
              name: 'Welcome Call Review',
              path: '/queue/welcome-call',
              defaultFilters: [],
            },
          ]
        : []),
    ];
  }, [
    defaultQueueFilterAsReadyAndReReview,
    defaultQueueFilterAsNotReady,
    ptoQueue,
    enableWarrantyRegistration,
    enableGeothermal,
    isLightReachQCTech,
    isLightReachSupport,
  ]);
};
